<div *ngIf="show" class="cookie-hint">
    <div class="cookie-hint-header">
        <button type="button"
                class="button button-small close-button"
                (click)="close()">
            <i class="rr-icon-remove"></i>
        </button>
    </div>

    <div class="cookie-hint-content">
        <p>
            Um unser Internetangebot für Sie optimal zu gestalten und fortlaufend verbessern zu können,
            verwenden wir Cookies sowie das Webanalyse-Tool Econda.
            Durch die weitere Nutzung dieser Webseite erklären Sie sich hiermit einverstanden.
            Eine Widerspruchsmöglichkeit gibt es
            <a href="https://toyota-bank-portal.de/ratenrechner/datenschutz.html"
               target="_blank"
               class="light">hier</a>
        </p>
    </div>

    <div class="cookie-hint-footer">
        <button type="button" class="button red button-small accept-button" (click)="accept()">OK</button>
    </div>
</div>